import angular from 'angular';
import VariationsForm from '../creatives/variationsForm';
import VariationsIndex from '../creatives/variationsIndex';
import BannerCreativesForm from '../creatives/bannerCreativesForm';
import VideoCreativesForm from '../creatives/videoCreativesForm';
import AudioCreativesForm from '../creatives/audioCreativesForm';
import MRaidPlayableCreativesForm from '../creatives/mraidPlayableCreativesForm';
import NativeAdCreativesForm from '../creatives/nativeAdCreativesForm';
import NativeVideoAdCreativesForm from '../creatives/nativeVideoAdCreativesForm';
import DynamicCreativesForm from '../creatives/dynamicCreativesForm';
import NativeCommonFieldsForm from '../creatives/nativeCommonFieldsForm';
import CreativesTextBlock from '../creatives/creativesTextBlock';
import CopyContentModal from '../creatives/copyContentModal';
import NativeAdPreview from '../creatives/nativeAdPreview';
import CreativesIndex from '../creatives/creativesIndex';

export default angular.module('app.components.creatives', [
  'ui.router',
  CreativesIndex.name,
  VariationsIndex.name,
  VariationsForm.name,
  BannerCreativesForm.name,
  VideoCreativesForm.name,
  AudioCreativesForm.name,
  MRaidPlayableCreativesForm.name,
  NativeAdCreativesForm.name,
  NativeVideoAdCreativesForm.name,
  DynamicCreativesForm.name,
  NativeCommonFieldsForm.name,
  CreativesTextBlock.name,
  CopyContentModal.name,
  NativeAdPreview.name
])
.config(function($stateProvider){
  $stateProvider
  .state('app.creatives', {
    abstract: true,
    url: '/games/:gameId/creatives',
    template: '<ui-view/>',
    data: {
      permissions: {
        except: ['anonymous', 'SELLER_ONLY'],
        redirectTo: 'login'
      }
    },
    resolve: {
      updateCurrentGame: function($stateParams,GamesResource,currentGame){
        return GamesResource.one($stateParams.gameId).get().then(game => {
          currentGame.onNext(game);
        });
      }
    }
  })
  .state('app.creatives.index', {
    url: '',
    template: '<creatives-index></creatives-index>',
    params: { variationsStatusFilterValue: null, searchTerm: '' },
    resolve: {
      $title: ($filter) => {
        return $filter('translate')('$state.app.creatives.index');
      }
    }
  })


})



/** WEBPACK FOOTER **
 ** ./src/components/creatives/creatives.js
 **/